import JobGradeComponent from 'components/Settings/Masters/JobGrade';
import PermissionGuard from 'components/Global/PermissionGuard';

export const JobGrade = () => {
	return (
		<PermissionGuard permission="Allow_Job_Grade">
			<JobGradeComponent />
		</PermissionGuard>
	);
};
